import React, { useState } from 'react'
import '../eventsApprovedRequest/EventsApprovedRequest.css'
import EventsRequested from './EventsRequested';
import EventsApproved from './EventsApproved';

const EventsApprovedRequest = () => {
     const [activeTab, setActiveTab] = useState(0);
  return (
    
    <div className='modal-box-sec following-modal-sec'>
        <div className="modal fade" id="EventsApproved1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div class="modal-body">
                        <div className="tabs-container">
                            <div className="tabs-header d-flex flex-wrap justify-content-center align-items-center gap-3">
                                <button  className={`tab-button d-flex align-items-center justify-content-center ${activeTab === 0 ? "active" : ""}`} onClick={() =>  setActiveTab(0)}>
                                <span className='text-btn'>Requested</span>
                                </button>
                                <button   className={`tab-button  d-flex align-items-center justify-content-center ${activeTab === 1 ? "active" : ""}`} onClick={() =>  setActiveTab(1)}>
                                <span className='text-btn'>Approved</span>
                                </button>
                            </div>

                            {/* Tab Content */}
                            <div className="tabs-content">
                            {activeTab === 0 && (
                                <div className="tab-panel">
                                    <EventsRequested />
                                </div>
                            )}
                            {activeTab === 1 && (
                                <div className="tab-panel">
                                    <EventsApproved />
                                </div>
                            )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default EventsApprovedRequest
